import React, { Component } from 'react';
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import RkHeader from '../../../GeneralComponents/RkHeader';
import FormCreate from './FormCreate';
import ShowChildren from './ShowChildren';
import ShowModalVideo from './ShowModalVideo'
import Preloader from '../../../GeneralComponents/LoadingComponen';
import Ckeditor from '../../formatos/Formats/Ckeditor'
import ReactHtmlParser from 'react-html-parser';

class Table extends Component {
    constructor(props) {
        super(props)
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            modal: false,
            modalShowInfo: false,
            modalShowVideo: false,
            ErrorValues: true,

            modeEditParent: false,
            modeEditChildren: false,

            addingChildrens: false,
            titleForm: "",
            id: "",
            numeral_child_id: "",

            file: null,
            submitBtnFile: false,
            parentId: "",

            // Collapse controlado por React (no depende del JS de Bootstrap).
            // id -> true = estándar colapsado (por defecto todos abiertos).
            collapsedParents: {},

            form: {
                name: "",
                patient_safety_standar: "",
                measurable_element: "",
                implementation_guide: "",
                service_area: "",
                iso_clause: "",
                video_url: "",
                normativity_id: this.props.normativity.id,
                proceso_ids: []
            },

            formChildren: {
                name: "",
                patient_safety_standar: "",
                measurable_element: "",
                implementation_guide: "",
                service_area: "",
                iso_clause: "",
                numeral_parent_id: "",
            },

            formUpdate: {
                measurable_element: "",
            },

            selectedOptionProcesos: {
                proceso_ids: "",
                label: "Procesos"
            },

            selectedOptionAreas: {
                service_area: "",
                label: "Área/servicio"
            },

            dataProcesos: [],
            dataProcesosEdit: [],
            dataAreas: [],
            subnumeralRegister: {},
            videUrl: "",

        }
    }

    messageSuccess = (response) => {
        Swal.fire({
            position: "center",
            type: `${response.type}`,
            title: `${response.success}`,
            showConfirmButton: false,
            timer: 1500,
        });
    };

    clearValuesForm = () => {
        this.setState({
            form: {
                name: "",
                patient_safety_standar: "",
                measurable_element: "",
                implementation_guide: "",
                service_area: "",
                iso_clause: "",
                video_url: "",
                normativity_id: this.props.normativity.id,
                proceso_ids: []
            },

            selectedOptionAreas: {
                service_area: "",
                label: "Área/servicio"
            },

            id: "",
            modeEditParent: false,
            addingChildrens: false,
            dataProcesosEdit: [],
        })
    }

    clearValuesFormChildren = () => {
        this.setState({
            formChildren: {
                name: "",
                patient_safety_standar: "",
                measurable_element: "",
                implementation_guide: "",
                service_area: "",
                iso_clause: "",
                numeral_parent_id: "",
            },

            id: "",
            addingChildrens: false,
            modeEditChildren: false,
        })
    }

    validationForm = () => {
        if (this.state.form.name != "") {
            this.setState({ ErrorValues: true })
            return true
        } else {
            this.setState({ ErrorValues: false })
            return false
        }
    }

    HandleChange = (e) => {
        this.setState({
            form: {
                ...this.state.form,
                [e.target.name]: e.target.value
            }
        });
    }

    toogle = (from) => {
        if (from == "new") {
            this.setState({ modal: true, titleForm: "Agregar Numeral", })
            this.clearValuesForm();
            this.clearValuesFormChildren()
        } else {
            this.setState({ modal: false })
            this.clearValuesForm();
            this.clearValuesFormChildren()
        }
    }

    HandleClick = () => {
        if (this.state.modeEditParent == false)
            fetch(`/health/normativity/${this.props.normativity.id}/numeral_parents`, {
                method: 'POST', // or 'PUT'
                body: JSON.stringify(this.state.form), // data can be `string` or {object}!
                headers: {
                    "X-CSRF-Token": this.token,
                    "Content-Type": "application/json"
                }
            })
                .then(res => res.json())
                .catch(error => console.error("Error:", error))
                .then(data => {
                    this.props.loadData();
                    this.clearValuesForm();
                    this.setState({ modal: false })
                    this.messageSuccess(data);
                });
        else {
            fetch(`/health/normativity/${this.props.normativity.id}/numeral_parents/${this.state.id}`, {
                method: 'PATCH', // or 'PUT'
                body: JSON.stringify(this.state.form), // data can be `string` or {object}!
                headers: {
                    "X-CSRF-Token": this.token,
                    "Content-Type": "application/json"
                }
            })
                .then(res => res.json())
                .catch(error => console.error("Error:", error))
                .then(data => {
                    this.props.updateItem(data.register);
                    this.clearValuesForm();
                    this.setState({ modal: false })
                    this.messageSuccess(data);
                });
        }
    }

    editParent = (parent) => {
        let arrayPositonEdit = []

        parent.procesos.map((item) => (
            arrayPositonEdit.push({ label: item.name, value: item.id })
        ))

        this.setState({
            form: {
                ...this.state.form,
                name: parent.name,
                patient_safety_standar: parent.patient_safety_standar,
                measurable_element: parent.measurable_element,
                implementation_guide: parent.implementation_guide,
                iso_clause: parent.iso_clause,
                video_url: parent.video_url,
                normativity_id: this.props.normativity.id,
                proceso_ids: parent.procesos,
                service_area: parent.service_area
            },

            selectedOptionAreas: {
                service_area: parent.service_area,
                label: `${parent.service_area}`
            },

            id: parent.id,
            titleForm: "Editar Numeral",
            modeEditParent: true,
            modeEditChildren: false,
            addingChildrens: false,
            modal: true,
            dataProcesosEdit: arrayPositonEdit
        })
    }



    delete = id => {
        Swal.fire({
            title: "¿Estás seguro?",
            text: "¡El registro será eliminado para siempre!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#009688",
            cancelButtonColor: "#d33",
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar"
        }).then(result => {
            if (result.value) {
                fetch(`/health/normativity/${this.props.normativity.id}/numeral_parents/${id}`, {
                    method: "delete",
                    headers: {
                        "X-CSRF-Token": this.token,
                        "Content-Type": "application/json"
                    }
                })
                    .then(response => response.json())
                    .then(response => {
                        this.props.loadData()
                        this.messageSuccess(response)
                    });
            }
        });
    };


    //Add childrens

    addChildren = (father) => {
        this.setState({
            titleForm: "Agregar Subnumeral",
            modal: true,
            addingChildrens: true,
            modeEditChildren: false,
            id: "",

            formChildren: {
                ...this.state.formChildren,
                name: "",
                patient_safety_standar: "",
                measurable_element: "",
                implementation_guide: "",
                service_area: "",
                iso_clause: "",
                numeral_parent_id: father.id
            }
        })
    }

    HandleChangeChildrens = (e) => {
        this.setState({
            formChildren: {
                ...this.state.formChildren,
                [e.target.name]: e.target.value
            }
        });
    }

    HandleClickChildrens = () => {
        if (this.state.modeEditChildren == false)
            fetch(`/health/numeral_child`, {
                method: 'POST', // or 'PUT'
                body: JSON.stringify(this.state.formChildren), // data can be `string` or {object}!
                headers: {
                    "X-CSRF-Token": this.token,
                    "Content-Type": "application/json"
                }
            })
                .then(res => res.json())
                .catch(error => console.error("Error:", error))
                .then(data => {
                    this.props.loadData();
                    this.clearValuesFormChildren();
                    this.setState({ modal: false })
                    this.messageSuccess(data);
                });
        else {
            fetch(`/health/numeral_child/${this.state.id}`, {
                method: 'PATCH', // or 'PUT'
                body: JSON.stringify(this.state.formChildren), // data can be `string` or {object}!
                headers: {
                    "X-CSRF-Token": this.token,
                    "Content-Type": "application/json"
                }
            })
                .then(res => res.json())
                .catch(error => console.error("Error:", error))
                .then(data => {
                    this.props.loadData();
                    this.clearValuesFormChildren();
                    this.setState({ modal: false })
                    this.messageSuccess(data);
                });
        }
    }

    editChildren = (children) => {
        this.setState({
            formChildren: {
                ...this.state.formChildren,
                name: children.name,
                patient_safety_standar: children.patient_safety_standar,
                measurable_element: children.measurable_element,
                implementation_guide: children.implementation_guide,
                service_area: children.service_area,
                iso_clause: children.iso_clause,
                numeral_parent_id: children.numeral_parent_id
            },

            id: children.id,
            titleForm: "Editar Subnumeral",
            modeEditChildren: true,
            modal: true,
            addingChildrens: true,
        })
    }

    deleteChildrents = id => {
        Swal.fire({
            title: "¿Estás seguro?",
            text: "¡El registro será eliminado para siempre!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#009688",
            cancelButtonColor: "#d33",
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar"
        }).then(result => {
            if (result.value) {
                fetch(`/health/numeral_child/${id}`, {
                    method: "delete",
                    headers: {
                        "X-CSRF-Token": this.token,
                        "Content-Type": "application/json"
                    }
                })
                    .then(response => response.json())
                    .then(response => {
                        this.props.loadData()
                        this.messageSuccess(response)
                    });
            }
        });
    };

    //muchos a muchos


    componentDidMount() {
        let arrayProcesos = []

        this.props.procesos.map((item) => (
            arrayProcesos.push({ label: item.name, value: item.id })
        ))

        this.setState({
            dataProcesos: arrayProcesos
        })


        let arrayAreas = []

        this.props.areas.map((item) => (
            arrayAreas.push({ label: item.name, value: item.id })
        ))

        this.setState({
            dataAreas: arrayAreas
        })
    }


    handleChangeAutocomplete = selectedOption => {
        let array = []

        selectedOption.map((item) => (
            array.push(item.value)
        ))

        this.setState({
            form: {
                ...this.state.form,
                proceso_ids: array
            }
        })
    };

    handleChangeAutocompleteAreas = selectedOptionAreas => {
        this.setState({
            selectedOptionAreas,
            form: {
                ...this.state.form,
                service_area: selectedOptionAreas.label
            }
        });
    };

    // subir padres

    uploadParents = (e) => {
        this.setState({
            file: e.target.files[0],
            submitBtnFile: (this.state.submitBtnFile == false ? true : false)
        });
    }

    uploadChildrents = (e) => {
        const formData = new FormData();
        formData.append("file", e.target.files[0])
        fetch(`/health/import_numeral_children/${this.state.parentId}`, {
            method: 'POST', // or 'PUT'
            body: formData, // data can be `string` or {object}!
            headers: {}
        })
            .then(res => res.json())
            .catch(error => console.error("Error:", error))
            .then(data => {
                this.props.loadData();
                this.setState({ parentId: "" })
                this.messageSuccess(data);
            });
    }


    handleClickUpload = () => {
        const formData = new FormData();
        formData.append("file", this.state.file)
        fetch(`/health/import_numeral_parent/${this.props.normativity.id}`, {
            method: 'POST', // or 'PUT'
            body: formData, // data can be `string` or {object}!
            headers: {}
        })
            .then(res => res.json())
            .catch(error => console.error("Error:", error))
            .then(data => {
                this.props.loadData();
                this.setState({ file: null, submitBtnFile: false })
                this.messageSuccess(data);
            });
    }


    getColor = (calification) => {
        if (calification == 11)
        {
            return "sin-color"
        }
        else if (calification < 6) {
            return "color-red"
        } else if (calification >= 6 && calification < 8) {
            return "color-orange"
        } else if (calification >= 8) {
            return "color-green"
        }
    }

    getScoreHex = (score) => {
        if (score == 11) return '#94a3b8';   // N/A
        if (score < 6) return '#ea7470';
        if (score < 8) return '#ffa600';
        return '#22c488';
    }

    getScore = (value) => {
        if (value && value[0] != undefined) {
            const score = value[0].score;
            return (
                <span className="rk-cal-pill" style={{ backgroundColor: this.getScoreHex(score) }}>
                    {score == 11 ? "N/A" : score}
                </span>
            );
        }
        return <span className="no-data-small">Sin calificación</span>;
    }

    //modal show subnumral

    toogleShow = (show, register) => {
        if (show == "show") {
            this.setState({ modalShowInfo: true, subnumeralRegister: register })
        } else {
            this.setState({ modalShowInfo: false, subnumeralRegister: {} })
        }
    }

    getBack = () => {
        let url = "/health/normativity?type=" + this.props.normativity.type
        Turbolinks.visit(url, "_self")
    }


    getNameTitle = (name) => {
        if (typeof window !== "undefined" && window.GS_TYPE_NAMES && window.GS_TYPE_NAMES[name]) {
            return window.GS_TYPE_NAMES[name];
        }
        if (name == "PCH" || name == "NMH") {
            return "Hospitales"
        } else if (name == "PCCAP") {
            return "Modelo Ambulatorio"
        } else if (name == "PCISO9001") {
            return "ISO 9001:2015 Salud"
        } else if (name == "PCISO15189") {
            return "ISO 7101:2023 HQM"
        } else if (name == "PCHEM") {
            return "Acreditación"
        } else if (name == "NCON") {
            return "Servicios Auxiliares"
        } else if (name == "NFAR") {
            return "Expediente Clínico"
        } else if (name == "NNOM") {
            return "Marco Legal"
        }
    }

    HandleChangeInplementionGuide = (e) => {
        this.setState({
            form: {
                ...this.state.form,
                implementation_guide: e,
            },
        })
    }

    editSon = (son) => {
        this.setState({
            formUpdate: {
                measurable_element: son.measurable_element,
            },

            numeral_child_id: son.id
        })
    }

    HandleChangeUpdate = (e) => {
        this.setState({
            formUpdate: {
                measurable_element: e,
            },
        })
    }

    HandleClickUpdate = () => {
        fetch(`/health/numeral_child/${this.state.numeral_child_id}`, {
            method: 'PATCH', // or 'PUT'
            body: JSON.stringify(this.state.formUpdate), // data can be `string` or {object}!
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(res => res.json())
        .catch(error => console.error("Error:", error))
        .then(data => {
            this.props.loadData();
            this.messageSuccess(data);
            this.setState({
                numeral_child_id: "",
                formUpdate: {
                    measurable_element: "",
                },
            })
        });
    }

    toogleShowVideo = (show, register) => {
        if (show == "show") {
            this.setState({ modalShowVideo: true, videUrl: register.video_url })
        } else {
            this.setState({ modalShowVideo: false, videUrl: "" })
        }
    }

    // Abre/cierra el estándar (colapsable) controlado por estado de React.
    toggleCollapse = (id) => {
        this.setState(state => ({
            collapsedParents: { ...state.collapsedParents, [id]: !state.collapsedParents[id] }
        }));
    }

    render() {
        return (
            <React.Fragment>

                <RkHeader
                    title={"Estándares y guías " + this.props.normativity.name}
                    subtitle={this.props.normativity.description}
                    titleNew={"Nuevo numeral"}
                    icon="fas fa-clipboard-check"
                    onClickNew={this.toogle}
                    showNew={this.props.estados.crear}
                    showFilter={false}
                >
                    <a
                        href={`/health/normativity/${this.props.normativity.id}`}
                        className="rk-head__btn rk-head__btn--ghost"
                        data-turbolinks="true"
                    >
                        <i className="fas fa-list-ul"></i> Ver evaluaciones
                    </a>
                </RkHeader>

                {this.state.modal && (
                    <FormCreate
                        //modal props
                        backdrop={"static"}
                        modal={this.state.modal}
                        toggle={this.toogle}
                        title={this.state.titleForm}

                        //form props
                        formValues={this.state.addingChildrens == false ? this.state.form : this.state.formChildren}
                        errorValues={this.state.ErrorValues}
                        onChangeForm={this.state.addingChildrens == false ? this.HandleChange : this.HandleChangeChildrens}
                        submitForm={this.state.addingChildrens == false ? this.HandleClick : this.HandleClickChildrens}

                        //muchos a muchos
                        handleChangeAutocomplete={this.handleChangeAutocomplete}
                        procesos={this.state.dataProcesos}
                        selectedOptionProcesos={this.state.selectedOptionProcesos}
                        editValuesProcesos={this.state.dataProcesosEdit}

                        //areas select
                        selectedOptionAreas={this.state.selectedOptionAreas}
                        onChangeAutocomplete={this.handleChangeAutocompleteAreas}

                        //ckaditor

                        HandleChangeInplementionGuide={this.HandleChangeInplementionGuide}
                        areas={this.props.areas}
                        key_text={this.props.key_text}
                    />
                )}

                {this.state.modalShowInfo && (
                    <ShowChildren
                        //modal props
                        backdrop={"static"}
                        modal={this.state.modalShowInfo}
                        toggle={this.toogleShow}
                        numeral_children={this.state.subnumeralRegister}
                        title={"Información de numeral"}
                    />
                )}

                {this.state.modalShowVideo && (
                    <ShowModalVideo
                        //modal props
                        backdrop={"static"}
                        modal={this.state.modalShowVideo}
                        toggle={this.toogleShowVideo}
                        video_url={this.state.videUrl}
                    />
                )}

                <div className="rk-wrap">

                    <nav className="rk-breadcrumb" aria-label="breadcrumb">
                        <a href="javascript:void(0);" onClick={() => this.getBack()}>
                            {this.getNameTitle(this.props.normativity.type)}
                        </a>
                        <span className="rk-breadcrumb__sep">/</span>
                        <span className="rk-breadcrumb__current">
                            Estándares y guías {this.props.normativity.name}
                        </span>
                    </nav>

                    {this.props.estados.importFiles && (
                        <div className="rk-toolbar">
                            <label htmlFor="fathers" className="rk-btn rk-btn--soft">
                                <i className="fas fa-file-excel"></i> Cargar Padres
                            </label>

                            <input
                                type="file"
                                id="fathers"
                                onChange={(e) => this.uploadParents(e)}
                                style={{ display: "none" }}
                            />

                            <input
                                type="file"
                                id="childrents"
                                onChange={(e) => this.uploadChildrents(e)}
                                style={{ display: "none" }}
                            />

                            {this.state.submitBtnFile && (
                                <button
                                    onClick={() => this.handleClickUpload()}
                                    className="rk-btn rk-btn--primary"
                                >
                                    Subir <i className="fas fa-file-upload"></i>
                                </button>
                            )}
                        </div>
                    )}

                    {this.props.isLoaded ? (
                        this.props.data.length >= 1 ? (
                            this.props.data.map(normativity => (
                                <div className="rk-panel" key={normativity.id} style={{ marginBottom: "16px" }}>

                                    <div className="rk-panel__head">
                                        {/* Chevron del acordeón — a la izquierda (como gestionmejora) */}
                                        <button
                                            type="button"
                                            className="rk-panel__chevron"
                                            title={this.state.collapsedParents[normativity.id] ? "Expandir" : "Colapsar"}
                                            onClick={() => this.toggleCollapse(normativity.id)}
                                        >
                                            <i
                                                className="fa fa-angle-down"
                                                style={{
                                                    transition: "transform .18s",
                                                    transform: this.state.collapsedParents[normativity.id] ? "rotate(-90deg)" : "rotate(0deg)"
                                                }}
                                            ></i>
                                        </button>

                                        <span className="rk-cell-primary rk-panel__title">
                                            {normativity.patient_safety_standar}
                                            {normativity.video_url != "" && (
                                                <i
                                                    className="fas fa-video show-video"
                                                    style={{ cursor: "pointer", color: "#2563eb", marginLeft: "6px" }}
                                                    onClick={() => this.toogleShowVideo("show", normativity)}
                                                ></i>
                                            )}
                                        </span>

                                        {/* Columna de calificación — ancho fijo, alineada con la del cuerpo */}
                                        <span className="rk-panel__score-col">
                                            {this.getScore(normativity.numeral_parent_scores)}
                                        </span>

                                        {/* Columna de menú — ancho fijo al final */}
                                        <UncontrolledDropdown className="rk-panel__menu-col">
                                            <DropdownToggle tag="button" className="rk-icon-btn">
                                                <i className="fas fa-ellipsis-v"></i>
                                            </DropdownToggle>
                                            <DropdownMenu right className="rk-menu">
                                                {this.props.estados.editar && (
                                                    <DropdownItem onClick={() => this.editParent(normativity)}>
                                                        <i className="fas fa-pen"></i> Editar
                                                    </DropdownItem>
                                                )}
                                                <DropdownItem onClick={() => this.toogleShow("show", normativity)}>
                                                    <i className="fas fa-info-circle"></i> Ver Información
                                                </DropdownItem>
                                            </DropdownMenu>
                                        </UncontrolledDropdown>
                                    </div>

                                    {!this.state.collapsedParents[normativity.id] && (
                                    <div className="rk-panel__body">
                                        <div className="rk-table-scroll">
                                            <table className="rk-table" style={{ tableLayout: "fixed" }}>
                                                <thead>
                                                    <tr>
                                                        <th>Elemento medible (Requisito)</th>
                                                        <th className="text-center" style={{ width: "150px" }}>Última calificación</th>
                                                        <th className="rk-table__actions"></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {normativity.numeral_children.map(son => (
                                                        <tr key={son.id}>
                                                            <td>
                                                                {son.id == this.state.numeral_child_id ? (
                                                                    <Ckeditor
                                                                        HandleChange={this.HandleChangeUpdate}
                                                                        formValues={this.state.formUpdate.measurable_element}
                                                                        key_text={this.props.key_text}
                                                                    />
                                                                ) : (
                                                                    <p
                                                                        className="text-two-lines"
                                                                        style={{ marginBottom: 0, cursor: this.props.estados.importFiles ? "pointer" : "default" }}
                                                                        onClick={() => this.props.estados.importFiles ? this.editSon(son) : null}
                                                                    >
                                                                        {ReactHtmlParser(son.measurable_element)}
                                                                    </p>
                                                                )}
                                                            </td>

                                                            <td className="text-center" style={{ width: "150px" }}>
                                                                {this.getScore(son.numeral_child_scores)}
                                                            </td>

                                                            <td className="rk-table__actions">
                                                                {son.id == this.state.numeral_child_id && (
                                                                    <span className="rk-inline-actions">
                                                                        <button
                                                                            className="rk-icon-btn rk-icon-btn--ok"
                                                                            title="Guardar"
                                                                            onClick={() => this.HandleClickUpdate()}
                                                                        >
                                                                            <i className="fas fa-check"></i>
                                                                        </button>
                                                                        <button
                                                                            className="rk-icon-btn rk-icon-btn--cancel"
                                                                            title="Cancelar"
                                                                            onClick={() => this.setState({ numeral_child_id: "" })}
                                                                        >
                                                                            <i className="fas fa-times"></i>
                                                                        </button>
                                                                    </span>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    )}
                                </div>
                            ))
                        ) : (
                            <div className="rk-table-card">
                                <div className="rk-empty">
                                    <i className="far fa-folder-open"></i>
                                    <p>No hay registros</p>
                                </div>
                            </div>
                        )
                    ) : (
                        <div className="col-md-12 text-center">
                            <Preloader />
                        </div>
                    )}

                </div>
            </React.Fragment>
        );
    }
}

export default Table;
